import { getUrlParam } from '@/utils';
import { getValue } from '@/utils/getValue';
import VaryQR from '@/components/ColorQrcode/VaryQR.js'


let refreshTimer = null;
let _varyQR = null
export const clearTimer = () => {
  clearInterval(refreshTimer);
  refreshTimer = null;
};

// 获取刷新的时间,因为一些老项目不能接口返回所以要写死多少秒刷新
const getFlushTime = (flushTime) => {
  const channel = getValue('channel');
  // 是否特殊的60s刷新二维码操作,因为这几个渠道是比较老得，没有通过接口和url传参，所以
  const showQrcode_60 = ['pingan'];
  if (showQrcode_60.includes(channel)) {
    flushTime = 60;
  }
  // 【KA】上海银行卡中心休息室权益项目 要求20秒刷新
  const showQrcode_20 = ['bankcomm', 'bosc'];
  if (showQrcode_20.includes(channel)) {
    flushTime = 20;
  }

  // 20240123 增加一个url参数专门控制二维码刷新时间，默认20秒，做了加密
  const refchannel = getValue('refchannel', {
    storageType: 'session',
  });
  if (refchannel) {
    try {
      const refStr = decodeURIComponent(refchannel);
      const refNum = Number(atob(refStr));
      flushTime = refNum || 20;
    } catch (error) {
      flushTime = 20;
    }
  }
  return flushTime;
};
export const createQrCode = async (qrcodeObj, dispatch) => {
  _varyQR && _varyQR.destroy()
  // 使用内部提供定时器

  const interval = 500 // 1000
  const option = Object.assign(
    {},
    {},
    {
      interval,
      logo: qrcodeObj.qrLogo || '',
      encodes: JSON.parse(qrcodeObj.riskCodes?.[0] || ''), 
      callback: async (canvas, instance) => {

        const _qrcode = await canvas.toDataURL('image/png')
        // 更新qrcode
        dispatch({
          type: 'use/setData',
          payload: {
            qrcodeMsg: { 
              ...qrcodeObj, 
              base64Data: _qrcode, 
              url: _qrcode, 
              // dragoncode: '' 
            }
          },
        })
        //setQrcode({ ...qrcodeObj, qrcode: _qrcode })

      }
    },
  );
  const varyQR = new VaryQR(9, '', option);
  _varyQR = await varyQR.start(qrcodeObj.qrcodeFormat);
};


const getQrcode = (dispatch, payload, traceId, callback) => {
  clearTimer();
  dispatch({
    type: 'use/queryflushQrcode',
    payload,
    traceId,
    callback: (res) => {
      const flushTime = getFlushTime(res.flushTime);
      if (res.risk) {
        createQrCode(res, dispatch)
      }
      if (callback) {
        callback(flushTime, res);
        return;
      }
      if (!flushTime) return;
      refreshTimer = setInterval(() => {
        dispatch({
          type: 'use/refreshQrcode',
          payload,
          traceId,
          callback: (res) => {
            if (res.risk) {
              createQrCode(res, dispatch)
            }
            if (res === false) {
              clearTimer();
            }
          },
        });
      }, flushTime * 1000);
    },
  });
};




export default getQrcode;
